/*
  Swaps the header logo between the white and navy versions depending on what's
  behind it: white over photos, video and dark sections; navy over light (paper)
  sections. Works for both the desktop and mobile logo images.
*/
(function () {
  var desk = document.querySelector('.header__logo-image.logo-desktop.logo-light-mode');
  var mob = document.querySelector('.header__logo-image.logo-mobile.logo-light-mode');
  if (!desk || !mob) return;
  var white = { src: desk.getAttribute('src'), set: desk.getAttribute('srcset') };
  var navy = { src: mob.getAttribute('src'), set: mob.getAttribute('srcset') };
  if (!white.src || !navy.src || white.src === navy.src) return;
  var logos = [desk, mob];

  function isLight(rgb) {
    var m = rgb && rgb.match(/[\d.]+/g);
    if (!m) return null;
    if (m.length > 3 && parseFloat(m[3]) < 0.5) return null; // transparent or faint tint: look further back
    return (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) / 255 > 0.6;
  }
  function behind(x, y) {
    var els = document.elementsFromPoint(x, y);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('.section-header')) continue;
      if (/^(IMG|VIDEO|CANVAS|IFRAME|PICTURE)$/.test(el.tagName)) return 'dark';
      var light = isLight(getComputedStyle(el).backgroundColor);
      if (light !== null) return light ? 'light' : 'dark';
    }
    return 'dark';
  }
  function set(img, file) {
    if (img.getAttribute('src') === file.src) return;
    img.src = file.src;
    if (file.set) img.srcset = file.set; else img.removeAttribute('srcset');
  }
  var ticking = false;
  function update() {
    ticking = false;
    logos.forEach(function (img) {
      var r = img.getBoundingClientRect();
      if (!r.width) return; // not the visible logo at this screen size
      // the header bar itself may be solid behind the logo; respect that first
      var bar = img.closest('.header-item');
      var barLight = bar ? isLight(getComputedStyle(bar).backgroundColor) : null;
      var tone = barLight !== null ? (barLight ? 'light' : 'dark') : behind(r.left + r.width / 2, r.top + r.height / 2);
      set(img, tone === 'light' ? navy : white);
    });
  }
  function queue() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  queue();
})();
